/**
 * Slice data between `start` ~ `end`.
 * Same with https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/slice
 */
export var Slice = function Slice(options) {
  var start = options.start,
    end = options.end;
  return function (data) {
    return data.slice(start, end);
  };
};
Slice.props = {};